export default __webpack_public_path__ + "static/media/EM0333.34I-41681_-24959_0.3db96e85.jpg";